// extracted by mini-css-extract-plugin
export default {"referralLink":"orgReferralRedirectLink_referralLink__attX8"};